import { gql } from '@apollo/client';

export const TRUCK_FIELDS = gql`
  fragment TruckFields on Truck {
    truckId
    transporterName
    truckRegistrationNumber
    tonnage
  }
`;
